export type AssessmentType =
  | 'WEB_APP'
  | 'API'
  | 'MOBILE_APP'
  | 'EXTERNAL_NETWORK'
  | 'INTERNAL_NETWORK'
  | 'CLOUD_CONFIG'
  | 'CLOUD_PENTEST'
  | 'M365_REVIEW'
  | 'VPN_FIREWALL_REVIEW'
  | 'AI_LLM'
  | 'CODE_REVIEW';

export type AssetCategory =
  | 'DIGITAL_APPLICATIONS'
  | 'INFRASTRUCTURE_NETWORKS'
  | 'CLOUD_SAAS_IDENTITY'
  | 'CODE_SUPPLY_CHAIN'
  | 'TBC';

export type Criticality = 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW' | 'NOT_SURE';

export type Exposure =
  | 'INTERNET_FACING'
  | 'INTERNAL_ONLY'
  | 'VPN_REQUIRED'
  | 'CLOUD_ACCOUNT_ACCESS'
  | 'SOURCE_REPO_ACCESS'
  | 'MOBILE_BUILD_REQUIRED'
  | 'TBC';

export type EnvironmentStage =
  | 'PRODUCTION'
  | 'STAGING'
  | 'ISOLATED_TEST'
  | 'DEVELOPMENT'
  | 'TBC';

export type TestingApproach =
  | 'BLACK_BOX'
  | 'GREY_BOX'
  | 'WHITE_BOX'
  | 'TBC';

export type AccessLevel =
  | 'NO_CREDENTIALS'
  | 'STANDARD_USER'
  | 'ADMIN'
  | 'MULTIPLE_USER_ROLES'
  | 'API_TOKEN'
  | 'OAUTH_CLIENT'
  | 'JWT'
  | 'MTLS'
  | 'READ_ONLY_CLOUD_ROLE'
  | 'SOURCE_CODE_ACCESS'
  | 'VPN_INTERNAL_NETWORK'
  | 'CREDENTIALED_READ_ONLY'
  | 'TBC';

export type TargetKind =
  | 'BASE_URL'
  | 'API_BASE_URL'
  | 'OPENAPI_URL'
  | 'POSTMAN_COLLECTION'
  | 'GRAPHQL_ENDPOINT'
  | 'APK_FILE'
  | 'IPA_FILE'
  | 'APP_STORE_URL'
  | 'IP'
  | 'CIDR'
  | 'HOSTNAME_LIST'
  | 'AD_DOMAIN'
  | 'AWS_ACCOUNT_ID'
  | 'AZURE_SUBSCRIPTION_ID'
  | 'GCP_PROJECT_ID'
  | 'TENANT_ID'
  | 'DEVICE_ID'
  | 'CONFIG_EXPORT'
  | 'ENDPOINT_URL'
  | 'REPOSITORY_URL'
  | 'OTHER';

export type BusinessAssetV2 = {
  asset_id: string;
  asset_name: string;
  asset_category: AssetCategory | null;
  criticality: Criticality | null;
  owner: { name: string | null; role: string | null };
  assessment_scopes: AssessmentScopeV2[];
};

export type AssessmentScopeV2 = {
  scope_id: string;
  assessment_type: AssessmentType | null;
  targets: TargetV2[];
  details?: Record<string, unknown>;
};

export type TargetV2 = {
  target_id: string;
  target_value: string | null;
  target_kind: TargetKind | null;
  exposure: Exposure | null;
  environment_stage: EnvironmentStage | null;
  testing_approach: TestingApproach | null;
  access_levels: AccessLevel[];
  sizing?: Record<string, number>;
};

export const EXPOSURE_BY_ASSESSMENT: Record<AssessmentType, Exposure[]> = {
  WEB_APP:             ['INTERNET_FACING', 'INTERNAL_ONLY', 'VPN_REQUIRED', 'TBC'],
  API:                 ['INTERNET_FACING', 'INTERNAL_ONLY', 'VPN_REQUIRED', 'TBC'],
  MOBILE_APP:          ['MOBILE_BUILD_REQUIRED', 'TBC'],
  EXTERNAL_NETWORK:    ['INTERNET_FACING'],
  INTERNAL_NETWORK:    ['INTERNAL_ONLY', 'VPN_REQUIRED', 'TBC'],
  CLOUD_CONFIG:        ['CLOUD_ACCOUNT_ACCESS'],
  CLOUD_PENTEST:       ['CLOUD_ACCOUNT_ACCESS', 'TBC'],
  M365_REVIEW:         ['CLOUD_ACCOUNT_ACCESS'],
  VPN_FIREWALL_REVIEW: ['INTERNAL_ONLY', 'VPN_REQUIRED', 'TBC'],
  AI_LLM:              ['INTERNET_FACING', 'INTERNAL_ONLY', 'TBC'],
  CODE_REVIEW:         ['SOURCE_REPO_ACCESS'],
};
